"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HOMEPAGE_PLAN_PAGE_VERSION, TRIAL_TERMS_LINE, TRIAL_TERMS_SHORT } from "@/lib/landing-constants";
import { phCapture, trackMarketingCtaClick } from "@/utils/analytics";
import { calloutDestination } from "@/lib/marketing/community-callout";

const SURFACE = { hero: "home_hero", demo: "home_how_it_works", final: "home_final_cta" } as const;

export function HeroTrialCta({ placement = "hero" }: { placement?: keyof typeof SURFACE }) {
  const surface = SURFACE[placement];
  const [planHref, setPlanHref] = useState("/learning-center/plan?from=homepage");
  useEffect(() => { setPlanHref(calloutDestination("/learning-center/plan?from=homepage", new URLSearchParams(window.location.search))); }, []);
  return (
    <div className="flex flex-col items-stretch gap-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
        <Button
          asChild
          size="lg"
          className="group btn-toplight press-scale bg-accent-value hover:bg-accent-value-strong text-zinc-950 px-5 py-6 text-base font-semibold rounded-xl"
        >
          <a
            href="#pricing"
            data-plan-chooser={surface}
            onClick={() =>
              trackMarketingCtaClick({
                surface,
                cta: placement === "hero" ? "get_started_free" : "start_trial",
                destination: "#pricing",
              })
            }
          >
            <span className="flex items-center justify-center gap-2">
              Try 5-Day Free Trial
              <ArrowRight className="size-5 group-hover:translate-x-1 transition-transform" />
            </span>
          </a>
        </Button>
        <Button
          asChild
          size="lg"
          variant="outline"
          className="press-scale px-5 py-6 text-base font-semibold rounded-xl"
        >
          <Link
            href={planHref}
            onClick={() => {
              phCapture("homepage_survey_cta_clicked", {
                surface,
                cta_placement: placement,
                page_version: HOMEPAGE_PLAN_PAGE_VERSION,
                destination: "/learning-center/plan",
              }, { send_instantly: true });
              trackMarketingCtaClick({ surface, cta: "find_betting_plan", destination: "/learning-center/plan" });
            }}
          >
            Find my betting plan
          </Link>
        </Button>
      </div>
      <p className="text-xs leading-relaxed text-muted-foreground">
        <span className="max-md:hidden">{TRIAL_TERMS_LINE} · Cancel anytime</span>
        <span className="md:hidden">{TRIAL_TERMS_SHORT} · Cancel anytime</span>
      </p>
    </div>
  );
}
